import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.getAccessToken()) {
        return router.createUrlTree(['/login']);
    }

    return authService.validateSession().pipe(
        map((isAuthenticated) => (isAuthenticated ? true : router.createUrlTree(['/login']))),
        catchError(() => of(router.createUrlTree(['/login']))),
    );
};
